import React from 'react';
import './AdminTr.css';

/**
 * @param {{
 *   children?: React.ReactNode,
 *   onClick?: (() => void) | null,
 *   className?: string
 * } & React.HTMLAttributes<HTMLTableRowElement>} props
 */
function AdminTr({ children, onClick = null, className = '', ...rest }) {
  return (
    <tr
      className={`au-tr au-scope${onClick ? ' is-clickable' : ''}${className ? ` ${className}` : ''}`}
      onClick={onClick || undefined}
      {...rest}
    >
      {children}
    </tr>
  );
}

export default AdminTr;
